import _classCallCheck from "D:/BuildAgent02/work/3584ffa7ff58f781/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "D:/BuildAgent02/work/3584ffa7ff58f781/node_modules/@babel/runtime/helpers/esm/createClass.js";
var InputHistory = /*#__PURE__*/function () {
  function InputHistory() {
    _classCallCheck(this, InputHistory);
    this.states = [];
    this.currentIndex = 0;
  }
  _createClass(InputHistory, [{
    key: "currentState",
    get: function get() {
      return this.states[this.currentIndex];
    }
  }, {
    key: "isEmpty",
    get: function get() {
      return this.states.length === 0;
    }
  }, {
    key: "push",
    value: function push(state) {
      // if current index points before the last element then remove the future
      if (this.currentIndex < this.states.length - 1) this.states.length = this.currentIndex + 1;
      this.states.push(state);
      if (this.states.length > InputHistory.MAX_LENGTH) this.states.shift();
      this.currentIndex = this.states.length - 1;
    }
  }, {
    key: "go",
    value: function go(steps) {
      this.currentIndex = Math.min(Math.max(this.currentIndex + steps, 0), this.states.length - 1);
      return this.currentState;
    }
  }, {
    key: "undo",
    value: function undo() {
      return this.go(-1);
    }
  }, {
    key: "redo",
    value: function redo() {
      return this.go(+1);
    }
  }, {
    key: "clear",
    value: function clear() {
      this.states.length = 0;
      this.currentIndex = 0;
    }
  }]);
  return InputHistory;
}();
InputHistory.MAX_LENGTH = 100;
export { InputHistory as default };